import pubsub from "@viewlift/pubsub"
import { ANALYTICSEVENTS } from "../../Helpers/analyticsMap"

export const triggerTveBeaconEvents = (eventType) => {
    const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
        let entitlementToken = localStorage.getItem('entitlementToken')
        let user = JSON.parse(entitlementToken)
        let mvpd = user?.mvpd || null
        let tveEventData = {
          "pageUrl": checkoutInitPageDetails?.pageUrl,
          "mvpdProvider": mvpd,
          "tveProvider": window?.app_data?.appcmsPlatform?.tveSettings?.tveProvider
      }
        let analyticsData={ename:ANALYTICSEVENTS[eventType],data: tveEventData};
        pubsub.publish('user-analytics',analyticsData)
  }
